export {
  immutableSetByPath,
  flattenToPointers,
  createStoreAdapter,
} from "./state-store";
export type { StoreAdapterConfig } from "./state-store";
